import React from 'react'
import { Button } from '@mui/material'

const CustomButton = ({
    title = 'CustomButton',
    variant = '',
    onClick,
    className,
    size,
    style,
    sx,
    ...props }) => {
    return (
        <Button
            className={className}
            variant={variant}
            onClick={onClick}
            size={size}
            sx={sx}
            style={style}
            {...props}
        >
            {title}
        </Button>
    )
}

export default CustomButton